<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      <div style="display: flex;align-items: center" class="mediaTitleList">
        <div
           v-for="(nav, index) in navTitle"
           :key="index"
           :class="idx === index ? 'active' : ''"
           style="cursor: pointer;padding:10px 20px;"
           @click="changeNav(index)">
          {{nav}}
        </div>
      </div>
    </template>
    <template v-slot:nav_right>
      <div class="yioks_btn" @click="$router.push('addMedia')">
        {{userRole === 'player' ? '上传个人训练或比赛视频剪辑' : '上传视频'}}
      </div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap" style="padding-bottom: 0;">
        <div class="select_box">
          <template v-if="userRole !== 'coach'">
            <select v-model="selectVal.organUuid" class="yioks_select" @change="changeOrg">
              <option value="" v-if="organList.length !== 1">全部区体育行政部门</option>
              <option
                v-for="item in organList"
                :key="item.organUuid"
                :value="item.organUuid">{{item.organShortName}}
              </option>
            </select>
            <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeCenter">
              <option value="" v-if="centerList.length !== 1">全部培训机构</option>
              <option
                v-for="item in centerList"
                :key="item.uuid"
                :value="item.uuid">{{item.youthShortName}}
              </option>
            </select>
          </template>
          <template v-else>
             <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeCoachCenter">
                <option value="" >全部培训机构</option>
                <option
                  v-for="item in squadCoachList"
                  :key="item.key"
                  :value="item.value">{{item.label}}
                </option>
              </select>
          </template>

        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.seacherString"
            type="text"
            class="yioks_input"
            style="width: 200px"
            placeholder="请输入关键字"
            @keyup.enter="changeQuery(true)">
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="mainContent">
        <yioks-loading v-if="loading"></yioks-loading>
        <template v-else>
          <yioks-empty v-if="empty"></yioks-empty>
          <vue-scroll v-else>
            <div class="mediaContent">
              <div v-for="(item,index) in mediaList" :key="index" class="half" @click.stop="goDetail(item.uuid)"  >
                <div class="half_content">
                  <div style="position: relative">
                    <img :src="item.videoCoverAddress || planImg " class="bg" alt="" @error="item.videoCoverAddress=planImg">
                    <img :src="playImg" @click.stop="openVideoDialog(item.videoAddress,item.videoCoverAddress)"  style="position: absolute;top: 30px;left: 65px;cursor: pointer">
                  </div>
                  <div  class="contentText">
                    <p>标题：{{item.videoTitle}}</p>
                    <p>上传人：{{item.authorName}}</p>
                    <p>时长： {{filterTime(parseInt(item.videoDuration / 60))}}:{{ filterTime(item.videoDuration % 60)}}</p>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </template>
      </div>
      <Pagination :total="total" :page.sync="page"/>
      <template v-if="showVideo">
        <el-dialog
          :visible.sync="showVideo"
          width="800px"
          class="linkAllDialog"
          :close-on-click-modal="false"
          top="12vh">
          <div style="text-align: center;background-color: black;width: 760px" >
            <video controls width="760" autoplay ref="video"
                   disablePictureInPicture
                   :poster="poster"
                   controlsList = "nodownload noremoteplayback" height="400">
              <source :src="videoSrc" type="video/mp4">
            </video>
          </div>
        </el-dialog>
      </template>
    </template>
  </SubContent>
</template>

<script>
import storage from '@/utils/storage'
import media from '@/api/media'
import coach from '@/api/coach'
import squad from '@/api/squad'
import { shareStatus } from '@/utils/yioks_filter'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'
// import storage from '@/utils/storage'
export default {
  name: 'index',
  components: {
    'SubContent': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination')
  },
  filters: {
    shareStatus
  },
  data () {
    return {
      playImg,
      planImg,
      poster: '',
      navTitle: [ '内部共享', '我的视频','参考视频'],
      empty: false,
      loading: false,
      idx: Number(this.$route.query.idx) || 0,
      organList: [],
      centerList: [],
      selectVal: {
        seacherString: this.$route.query.key || '',
        youthUuid: this.$route.query.youthUuid || '',
        organUuid: this.$route.query.organUuid || '',
      },
      showVideo: false,
      videoSrc: '',
      videoTitle: '',
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      mediaList: [],
      page: 0,
      pageSize: 20,
      total: 0,
      squadCoachList: [],
    }
  },
  watch: {
    showVideo: {
      handler (val) {
        if (!val) {
          this.videoSrc = ''
        }
      }
    },
    page () {
      this.changeQuery()
    }
  },
  created () {
    if(this.userRole !== 'coach') {
      this.getCenterList()
    } else {
      this.loadCoachCenterList();
    }
  },
  methods: {
    changeNav (index) {
      if (this.idx === index) return
      this.page = 0;
      this.total = 0;
      this.idx = index
      this.changeQuery(true)
    },
    getCenterList () {
      let data = this.uuid
      let request = coach.getCenterListByYouth
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
        // data = this.uuid
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      } else {
        request = coach.getCenterListByOther
        data = ''
      }
      request(data).then((res) => {
        this.organList = res
        if (this.selectVal.organUuid) {
          this.centerList = this.organList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList|| []
        } else {
          if (this.organList.length === 1) {
            this.selectVal.organUuid = this.organList[0].organUuid
            this.centerList = this.organList[0].youthList || []
          }
        }
        if (this.centerList.length === 1) {
          if (!this.selectVal.youthUuid) {
            this.selectVal.youthUuid = this.centerList[0].uuid
          }
        }
        this.getMediaList()
      })
    },
    // 教练获取搜索项可选内容
    loadCoachCenterList() {
      const _ = require('lodash');
      squad.getSquadListCoachAllToCoach()
      .then(res => {
        if(res.code) {
          this.$message.error(res.msg)
          return
        }
        const uni_selectYouthList = _.unionBy(res, "youthUuid");
        this.squadCoachList = uni_selectYouthList.map((item) => ({
          label: `${item.organShortName} - ${item.youthShortName}`,
          value: item.youthUuid,
          key: JSON.stringify({ squadUuid: item.squadUuid, youthUuid: item.youthUuid, organUuid: item.organUuid })
        }));
        this.getMediaList()
      })
    },
    changeOrg () {
      this.centerList = []
      this.$set(this.selectVal, 'youthUuid', '')
      if (this.selectVal.organUuid) {
        const { youthList } = this.organList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        })
        this.centerList = youthList || []
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
        }
      }
      this.changeQuery(true)
    },
    changeCenter () {
      this.changeQuery(true)
    },
    changeCoachCenter() {
      this.changeQuery(true)
    },
    openVideoDialog (src, poster) {
      // this.videoTitle = title
      this.videoSrc = src
      this.poster = poster || ''
      this.showVideo = true
      // this.$nextTick(() => {
      //   this.$refs['video']['disablePictureInPicture'] = true
      // })
    },
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    getMediaList () {
      let request
      if (this.idx === 2) {
        this.empty = true
        this.loading = false
        return
      } else if (this.idx === 0) {
        if (this.userRole === 'system' || this.userRole === 'admin') {
          request = media.videoListSystem
        } else if (this.userRole === 'organ') {
          request = media.videoListOrgan
        } else if(this.userRole === 'coach'){
          request = media.videoListYouthForCoach
        } else {
          request = media.videoListYouth
        }
      } else if (this.idx === 1) {
        request = media.videoListMy
      }
      this.loading = true
      request({ page: this.page, size: this.pageSize,key:this.selectVal.seacherString, organUuid: this.selectVal.organUuid, youthUuid: this.selectVal.youthUuid }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.empty = false
          this.total = res.totalElements
          this.mediaList = res.content
        }
      }).catch(err=>{
        this.loading = false
      })
    },
    goDetail (uuid) {
      this.$router.push({
        path: 'detail',
        query: {
          uuid
        }
      })
    },
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          key: this.selectVal.seacherString,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          idx: this.idx
        }
      })
      this.getMediaList()
    }
  }
}
</script>

<style scoped lang="stylus">
.mediaTitleList
  .active
    background-color #4cd964
.mainContent
  padding 20px 0  0 20px
  height 510px
  .mediaContent
    padding-right 40px
    display flex
    justify-content space-between
    flex-wrap wrap
    align-items center
    .half
      flex-basis: 48%;
      padding 15px 20px
      background-color rgba(0,0,0,.7)
      margin-bottom 10px
      cursor pointer
      .half_content
        display flex
        .bg
          width: 170px
          height: 100px
        .contentText
          margin-left 10px
          display: flex;
          flex-direction: column;
          justify-content: space-between

</style>
